class Cart extends HTMLElement {
  constructor() {
    super();

    if (!window.__drawerCartInitialized) {
      window.__drawerCartInitialized = true;

      this.handleToggleDrawerCart();
      this.handleQuantityFields();
      this.handleAddToCart();
      this.handleRemoveFromCart();
      this.handleProductVariants();
      this.handleTabs();
      this.handleFreeGift();
      this.handleCartNote();

      if (Shopify.designMode) {
        this.handleBlockSelect();
      }
    }
  }

  handleToggleDrawerCart() {
    document.querySelectorAll('.js-open-drawer-cart').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const drawer = document.querySelector('.js-drawer-cart');
        if (!drawer) return;

        drawer.classList.add('display');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        setTimeout(() => {
          drawer.classList.add('active');
        }, 50);
      });
    });

    document.querySelectorAll('.js-close-drawer-cart').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const drawer = document.querySelector('.js-drawer-cart');
        if (!drawer) return;

        drawer.classList.add('closing');
        setTimeout(() => {
          drawer.classList.remove('active', 'closing', 'display');
          document.body.style.overflow = 'visible';
          document.documentElement.style.overflow = 'visible';
        }, 300);
      });
    });
  }

  handleQuantityFields() {
    document.body.addEventListener('click', async (event) => {
      const target = event.target.closest('.js-change-quantity');
      if (!target) return;

      event.preventDefault();

      const giftCartItem = target.closest(
        '.js-cart-item[data-free-gift="true"]'
      );

      if (giftCartItem) {
        return;
      }

      const container = target.closest('.js-cart-item');
      if (!container) return;

      target.classList.add('loading');

      const variantId = parseInt(
        target.getAttribute('data-variant-id'),
        10
      );

      const newQuantity = parseInt(
        target.getAttribute('data-quantity'),
        10
      );

      const quantityInput = container.querySelector(
        '.js-quantity-field-input'
      );

      const currentQuantity = parseInt(
        quantityInput?.value || 0,
        10
      );

      const freeProductVariantId = parseInt(
        container.getAttribute('data-free-product'),
        10
      );

      const quantityDifference =
        newQuantity - currentQuantity;

      container.style.height = `${container.offsetHeight}px`;

      try {
        const cartBeforeUpdate = await this.getCart();

        const paidItem = cartBeforeUpdate.items.find(item =>
          item.variant_id === variantId &&
          item.properties?._free_gift !== 'true'
        );

        if (!paidItem) {
          throw new Error('Paid cart item not found');
        }

        let cart = await this.changeFreeGiftQuantity(
          paidItem.key,
          newQuantity
        );

        let newFreeProductQuantity = null;

        if (
          freeProductVariantId &&
          freeProductVariantId !== variantId
        ) {
          const linkedPaidItem = cart.items.find(item =>
            item.variant_id === freeProductVariantId &&
            item.properties?._free_gift !== 'true'
          );

          if (linkedPaidItem) {
            newFreeProductQuantity = Math.max(
              linkedPaidItem.quantity + quantityDifference,
              0
            );

            cart = await this.changeFreeGiftQuantity(
              linkedPaidItem.key,
              newFreeProductQuantity
            );
          }
        }

        if (newQuantity < 1) {
          container.classList.add('hide-item');

          setTimeout(() => {
            container.remove();

            if (cart.item_count === 0) {
              document
                .querySelector('.js-cart-content')
                ?.classList.add(
                  'drawer-cart__content--empty'
                );
            }
          }, 300);

        } else {
          if (quantityInput) {
            quantityInput.value = newQuantity;
          }

          const minus = container.querySelector(
            '.js-quantity-minus'
          );

          const plus = container.querySelector(
            '.js-quantity-plus'
          );

          if (minus) {
            minus.setAttribute(
              'data-quantity',
              newQuantity - 1
            );
          }

          if (plus) {
            plus.setAttribute(
              'data-quantity',
              newQuantity + 1
            );
          }
        }

        if (
          freeProductVariantId &&
          newFreeProductQuantity !== null
        ) {
          this.updateLinkedFreeProductUI(
            freeProductVariantId,
            newFreeProductQuantity
          );
        }

        this.updateCartTotals(cart);

        const freeDelivery =
          document.querySelector(
            '.js-free-delivery'
          );

        if (freeDelivery) {
          let width = 0;

          const limit = parseInt(
            freeDelivery.getAttribute(
              'data-limit'
            ),
            10
          );

          let price =
            Shopify.formatMoney(0);

          if (cart.total_price >= limit) {
            width = 100;

            freeDelivery.classList.add(
              'active'
            );

          } else {
            freeDelivery.classList.remove(
              'active'
            );

            if (cart.total_price > 0) {
              width =
                (cart.total_price / limit) *
                100;

              price =
                Shopify.formatMoney(
                  limit -
                  cart.total_price
                );

              const spendMore =
                document.querySelector(
                  '.js-cart-spend-more-money'
                );

              if (spendMore) {
                spendMore.innerHTML =
                  freeDelivery
                    .getAttribute(
                      'data-spend-more-text'
                    )
                    .replace(
                      '[price]',
                      price
                    );
              }
            }
          }

          const bar =
            document.querySelector(
              '.js-free-delivery-bar'
            );

          if (bar) {
            bar.style.width =
              `${width}%`;
          }
        }

        document
          .querySelectorAll(
            '.js-cart-counter'
          )
          .forEach(cartCounter => {
            cartCounter.innerHTML =
              cart.item_count;

            cartCounter.setAttribute(
              'data-counter',
              cart.item_count
            );
          });

        cart = await this.syncFreeGift(cart);

        this.updateCartRecommendations(cart);

      } catch (error) {
        console.error(
          'Cart quantity update error:',
          error
        );

        alert(
          error.message ||
          'Error'
        );

      } finally {
        document
          .querySelectorAll(
            '.js-change-quantity'
          )
          .forEach(el =>
            el.classList.remove(
              'loading'
            )
          );
      }
    });
  }

  updateLinkedFreeProductUI(
    variantId,
    quantity
  ) {
    const cartItem =
      document.querySelector(
        `.js-cart-item[data-variant-id="${variantId}"][data-free-gift="false"]:not(.hide-item)`
      );

    if (!cartItem) return;

    if (quantity <= 0) {
      cartItem.classList.add(
        'hide-item'
      );

      setTimeout(() => {
        cartItem.remove();
      }, 300);

      return;
    }

    const input =
      cartItem.querySelector(
        '.js-quantity-field-input'
      );

    if (input) {
      input.value = quantity;
    }

    const minus =
      cartItem.querySelector(
        '.js-quantity-minus'
      );

    const plus =
      cartItem.querySelector(
        '.js-quantity-plus'
      );

    if (minus) {
      minus.setAttribute(
        'data-quantity',
        quantity - 1
      );
    }

    if (plus) {
      plus.setAttribute(
        'data-quantity',
        quantity + 1
      );
    }
  }

  validateEmail(email) {
    const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailReg.test(email);
  }

  handleAddToCart() {
    document.body.addEventListener("click", (event) => {
      const target = event.target.closest(".js-add-to-cart");
      if (!target) return;

      event.preventDefault();

      let properties = {};

      const productElement = target.closest(
        '.js-product'
      );

      if (!productElement) return;

      const productId = productElement.getAttribute('data-product-id');

      let quantity =
        productElement.querySelector('.js-quantity-field')?.value || 1;

      quantity = parseInt(quantity, 10);

      if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
      }

      const id = productElement.querySelector(
        `#product-select-${productId}`
      )?.value;

      if (!id) return;

      const recipientEmail = productElement?.querySelector(
        "input[name='properties[Recipient email]']"
      );

      const recipientName = productElement?.querySelector(
        "input[name='properties[Recipient name]']"
      );

      const senderName = productElement?.querySelector(
        "input[name='properties[Sender name]']"
      );

      const message = productElement?.querySelector(
        "textarea[name='properties[Message]']"
      );

      const sendOn = productElement?.querySelector(
        "input[name='properties[Send on]']"
      );

      if (recipientEmail) {
        const email = recipientEmail.value.trim();

        if (email && !this.validateEmail(email)) {
          alert("Invalid e-mail!");
          recipientEmail.focus();
          return;
        }

        if (email) {
          properties = {
            "__shopify_send_gift_card_to_recipient": true,
            "Recipient email": email,
            "Recipient name": recipientName?.value.trim() || "",
            "Sender name": senderName?.value.trim() || "",
            "Message": message?.value.trim() || ""
          };

          if (sendOn?.value) {
            properties["Send on"] = sendOn.value;
          }
        }
      }

      const addingText = target.getAttribute("data-adding-text");

      if (addingText) {
        const innerTextEl = target.querySelector(".js-add-to-cart-text");

        if (innerTextEl) {
          innerTextEl.textContent = addingText;
        } else {
          target.innerHTML = addingText;
        }
      }

      target.classList.add("loading");

      const image = target.getAttribute("data-featured-image");

      const mainItem = {
        id: parseInt(id, 10),
        quantity: parseInt(quantity, 10)
      };

      if (Object.keys(properties).length > 0) {
        mainItem.properties = properties;
      }

      const items = [
        mainItem
      ];

      const freeProduct =
        productElement?.querySelector(
          '.js-free-product'
        );

      let freeVariantId = null;

      if (freeProduct) {
        freeVariantId = parseInt(
          freeProduct.getAttribute(
            'data-variant-id'
          ),
          10
        );
      }

      if (
        freeProduct &&
        freeProduct.checked &&
        freeVariantId
      ) {
        items.push({
          id: freeVariantId,
          quantity: parseInt(
            quantity,
            10
          )
        });
      }

      const formData = {
        items
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.description || 'Something went wrong');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .then(response => {
        response.items.forEach(itemData => {
          const variantId = itemData.variant_id;

          let cartItem = document.querySelector(
            `.js-cart-item[data-variant-id='${variantId}'][data-free-gift="false"]:not(.hide-item)`
          );

          if (cartItem) {
            if (
              itemData.variant_id === parseInt(id, 10) &&
              freeVariantId
            ) {
              cartItem.setAttribute(
                'data-free-product',
                freeVariantId
              );
            }

            const quantityField = cartItem.querySelector(".js-quantity-field-input");
            const quantityMinus = cartItem.querySelector(".js-quantity-minus");
            const quantityPlus = cartItem.querySelector(".js-quantity-plus");

            if (quantityField) {
              quantityField.value = itemData.quantity;
            }

            if (quantityMinus) {
              quantityMinus.setAttribute(
                "data-quantity",
                itemData.quantity - 1
              );
            }

            if (quantityPlus) {
              quantityPlus.setAttribute(
                "data-quantity",
                itemData.quantity + 1
              );
            }

            return;
          }

          const quantityMinus = itemData.quantity - 1;
          const quantityPlus = itemData.quantity + 1;

          const originalPrice =
            itemData.original_price ?? itemData.price;

          const finalPrice =
            itemData.final_price ?? itemData.price;

          const formattedFinalPrice =
            finalPrice === 0
              ? 'Free'
              : Shopify.formatMoney(finalPrice);

          const priceHtml =
            originalPrice !== finalPrice
              ? `
                <span class="cart-item__price-old">
                  ${Shopify.formatMoney(originalPrice)}
                </span>
                ${formattedFinalPrice}
              `
              : formattedFinalPrice;

          const itemImage =
            itemData.featured_image?.url ||
            itemData.image ||
            image ||
            '';

          const linkedFreeProduct =
            itemData.variant_id === parseInt(id, 10) &&
            freeVariantId
              ? `data-free-product="${freeVariantId}"`
              : '';

          const item = `
            <li
              class="cart-item d-flex js-cart-item"
              data-variant-id="${itemData.variant_id}"
              data-free-gift="false"
              ${linkedFreeProduct}
            >
              <div class="cart-item__image">
                <a href="${itemData.url}">
                  <img
                    src="${itemImage}"
                    width="190"
                    height="auto"
                    alt="${itemData.product_title}"
                    class="fade-in"
                    loading="lazy"
                  >
                </a>
              </div>

              <div class="cart-item__details">

                <div class="cart-item__remove">
                  <a
                    href="#"
                    class="js-change-quantity"
                    data-variant-id="${itemData.variant_id}"
                    data-quantity="0"
                  >
                    Remove
                  </a>
                </div>

                <div class="cart-item__title">
                  <a href="${itemData.url}">
                    ${itemData.product_title}
                  </a>
                </div>

                ${(itemData.options_with_values || [])
                  .filter(option => option.name !== 'Title')
                  .map(option => `
                    <div class="cart-item__option">
                      ${option.name}: ${option.value}
                    </div>
                  `)
                  .join('')}

                <div class="cart-product__quantity-and-price d-flex align-items-center js-quantity-fields">

                  <div class="cart-product__quantity-field">

                    <div class="quantity-field__minus">
                      <a
                        href="#"
                        class="js-change-quantity js-quantity-minus"
                        data-variant-id="${itemData.variant_id}"
                        data-quantity="${quantityMinus}"
                      >
                        -
                      </a>
                    </div>

                    <input
                      type="text"
                      value="${itemData.quantity}"
                      class="quantity-field__input js-quantity-field-input"
                      disabled="disabled"
                    >

                    <div class="quantity-field__plus">
                      <a
                        href="#"
                        class="js-change-quantity js-quantity-plus"
                        data-variant-id="${itemData.variant_id}"
                        data-quantity="${quantityPlus}"
                      >
                        +
                      </a>
                    </div>

                  </div>

                  <div class="cart-item__price">
                    ${priceHtml}
                  </div>

                </div>

              </div>
            </li>
          `;

          document
            .querySelector(".js-cart-items")
            ?.insertAdjacentHTML("beforeend", item);
        });

        return fetch(
          window.Shopify.routes.root + 'cart.js'
        ).then(response => response.json());
      })
      .then(async cart => {
        cart = await this.syncFreeGift(cart);

        this.updateCartRecommendations(cart);

        document.querySelectorAll(".js-change-quantity").forEach(el => el.classList.remove("loading"));

        this.updateCartTotals(cart);

        let freeDeliveryElement = document.querySelector(".js-free-delivery");
        if (freeDeliveryElement) {
          let width = 0;
          let limit = parseInt(freeDeliveryElement.getAttribute("data-limit"));
          let price = Shopify.formatMoney(0);

          if (cart.total_price >= limit) {
            width = 100;
            freeDeliveryElement.classList.add("active");
          } else {
            freeDeliveryElement.classList.remove("active");
            if (cart.total_price > 0) {
              width = (cart.total_price / limit) * 100;
              price = Shopify.formatMoney(limit - cart.total_price);
              document.querySelector(".js-cart-spend-more-money").innerHTML =
                  freeDeliveryElement.getAttribute("data-spend-more-text").replace("[price]", price);
            }
          }
          document.querySelector(".js-free-delivery-bar").style.width = width + "%";
        }

        document.querySelector(".js-cart-content")?.classList.remove("drawer-cart__content--empty");
        document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
          cartCounter.innerHTML = cart.item_count;
          cartCounter.setAttribute('data-counter', cart.item_count);
        });
        document.querySelector('.js-drawer-cart')?.classList.add('display');
        setTimeout(() => {
          document.querySelector('.js-drawer-cart')?.classList.add('active');
        }, 50);
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.querySelectorAll('.js-add-to-cart').forEach(button => {
          button.classList.remove('loading');
          const originalText = button.getAttribute('data-original-text');
          if (!originalText) return;
          const innerTextEl = button.querySelector('.js-add-to-cart-text');
          if (innerTextEl) {
            innerTextEl.textContent = originalText;
          } else {
            button.textContent = originalText;
          }
        });
      })
      .catch(async (error) => {
        let message = 'Unexpected error';

        try {
          const text = await error.text();
          const json = JSON.parse(text);
          if (json && json.description) {
            message = json.description;
          }
        } catch (e) {
          message = error.message || 'Something went wrong';
        }

        alert(message);
        window.location.reload();
      });
    });
  }

  handleRemoveFromCart() {
    document.body.addEventListener('click', async (event) => {
      const target = event.target.closest('.js-remove-from-cart');

      if (!target) return;

      event.preventDefault();

      const variantId = parseInt(
        target.getAttribute('data-variant-id'),
        10
      );

      if (!variantId) return;

      target.classList.add('loading');

      try {
        const productElement = target.closest('.js-product');

        const freeProduct = productElement?.querySelector(
          '.js-free-product'
        );

        const freeVariantId = parseInt(
          freeProduct?.getAttribute('data-variant-id') || 0,
          10
        );

        const beforeRemove = await this.getCart();
        const paidItem = beforeRemove.items.find(item =>
          item.variant_id === variantId &&
          item.properties?._free_gift !== 'true'
        );

        if (!paidItem) return;

        let cart = await this.changeFreeGiftQuantity(paidItem.key, 0);

        if (freeVariantId && freeVariantId !== variantId) {
          const linkedPaidItem = cart.items.find(item =>
            item.variant_id === freeVariantId &&
            item.properties?._free_gift !== 'true'
          );

          if (linkedPaidItem) {
            cart = await this.changeFreeGiftQuantity(linkedPaidItem.key, 0);
          }
        }

        cart = await this.syncFreeGift(cart);

        this.updateCartRecommendations(cart);

        this.updateCartTotals(cart);

        window.location.reload();

      } catch (error) {
        console.error('Remove from cart error:', error);

        alert(
          error.message ||
          'Could not remove product'
        );

        target.classList.remove('loading');
      }
    });
  }

  handleProductVariants() {
    document.body.addEventListener('click', (event) => {
      const variant = event.target.closest('.js-product-variant');

      if (!variant) return;

      event.preventDefault();

      const product = variant.closest('.js-product');
      if (!product) return;

      const productId = product.dataset.productId;
      const select = product.querySelector(`#product-select-${productId}`);

      if (!select) return;

      select.value = variant.dataset.variantId;

      product.querySelectorAll('.js-product-variant').forEach(item => {
        item.classList.remove('active');
      });

      variant.classList.add('active');

      const priceElement = product
        .closest('section')
        ?.querySelector('.js-product-price');

      if (priceElement && variant.dataset.variantPrice) {
        priceElement.innerHTML = variant.dataset.variantPrice;
      }
    });
  }

  handleTabs() {
    document.body.addEventListener('click', (event) => {
      const title = event.target.closest('.js-cart-tab-title');
      if (!title) return;

      const tab = title.closest('.js-cart-tab');
      const content = tab?.querySelector('.js-cart-tab-content');

      if (!tab || !content) return;

      tab.classList.toggle('active');

      if (tab.classList.contains('active')) {
        content.style.maxHeight = `${content.scrollHeight}px`;
      } else {
        content.style.maxHeight = '0px';
      }
    });
  }

  renderFreeGiftItem(item) {
    const cartItems = document.querySelector('.js-cart-items');
    if (!cartItems) return;

    const existingItem = cartItems.querySelector(
      `.js-cart-item[data-variant-id="${item.variant_id}"][data-free-gift="true"]:not(.hide-item)`
    );

    if (existingItem) {
      this.protectFreeGiftItemUI(item.variant_id);
      return;
    }

    const image =
      item.featured_image?.url ||
      item.image ||
      '';

    const originalPrice = item.original_price ?? item.price;
    const finalPrice = item.final_price ?? item.price;

    const originalGiftPrice = parseInt(
      document
        .querySelector('.js-cart-free-gift')
        ?.getAttribute('data-original-price') || 0,
      10
    );

    const priceHtml = `
      <span class="cart-item__price-old">
        ${Shopify.formatMoney(originalGiftPrice)}
      </span>

      ${finalPrice === 0 ? 'Free' : Shopify.formatMoney(finalPrice)}
    `;

    const html = `
      <li
        class="cart-item cart-item--free-gift d-flex js-cart-item"
        data-variant-id="${item.variant_id}"
        data-free-gift="true"
      >
        <div class="cart-item__image">
          <img
            src="${image}"
            width="190"
            height="auto"
            alt="${item.product_title}"
            class="fade-in"
            loading="lazy"
          >
        </div>

        <div class="cart-item__details">

          <div class="cart-item__title">
            ${item.product_title}
          </div>

          ${(item.options_with_values || [])
            .filter(option => option.name !== 'Title')
            .map(option => `
              <div class="cart-item__option">
                ${option.name}: ${option.value}
              </div>
            `)
            .join('')}

          <div class="cart-product__quantity-and-price d-flex align-items-center">

            <div class="cart-product__quantity-field">
              <div class="quantity-field__input">
                1
              </div>
            </div>

            <div class="cart-item__price">
              ${priceHtml}
            </div>

          </div>

        </div>
      </li>
    `;

    cartItems.insertAdjacentHTML('beforeend', html);

    this.protectFreeGiftItemUI(item.variant_id);
  }

  updateFreeGiftItemPrice(item) {
    if (!item) return;

    const cartItem = document.querySelector(
      `.js-cart-item[data-variant-id="${item.variant_id}"][data-free-gift="true"]:not(.hide-item)`
    );

    if (!cartItem) return;

    const priceElement = cartItem.querySelector('.cart-item__price');
    if (!priceElement) return;

    const freeGift = document.querySelector(
      `.js-cart-free-gift[data-variant-id="${item.variant_id}"]`
    );

    const originalPrice = parseInt(
      freeGift?.dataset.originalPrice || 0,
      10
    );

    const finalPrice = item.final_price ?? item.price ?? 0;

    priceElement.innerHTML = `
      <span class="cart-item__price-old">
        ${Shopify.formatMoney(originalPrice)}
      </span>
      ${finalPrice === 0 ? 'Free' : Shopify.formatMoney(finalPrice)}
    `;
  }

  protectFreeGiftItemUI(variantId) {
    const cartItem = document.querySelector(
      `.js-cart-item[data-variant-id="${variantId}"][data-free-gift="true"]:not(.hide-item)`
    );

    if (!cartItem) return;

    cartItem.setAttribute('data-free-gift', 'true');
    cartItem.classList.add('cart-item--free-gift');

    const quantityInput = cartItem.querySelector('.js-quantity-field-input');

    if (quantityInput) {
      quantityInput.value = 1;
    }

    cartItem.querySelectorAll('.js-quantity-minus').forEach(button => {
      const wrapper = button.closest('.quantity-field__minus');

      if (wrapper) {
        wrapper.remove();
      } else {
        button.remove();
      }
    });

    cartItem.querySelectorAll('.js-quantity-plus').forEach(button => {
      const wrapper = button.closest('.quantity-field__plus');

      if (wrapper) {
        wrapper.remove();
      } else {
        button.remove();
      }
    });

    cartItem.querySelectorAll(
      '.cart-item__remove, .cart-item__delete'
    ).forEach(element => {
      element.remove();
    });

    cartItem.querySelectorAll('.js-change-quantity').forEach(button => {
      button.remove();
    });

    cartItem.querySelectorAll('.cart-item__image > a').forEach(link => {
      link.replaceWith(...link.childNodes);
    });

    cartItem.querySelectorAll('.cart-item__title > a').forEach(link => {
      link.replaceWith(...link.childNodes);
    });

    const title = cartItem.querySelector('.cart-item__title');

    if (
      title &&
      !cartItem.querySelector('.cart-item__free-gift-label')
    ) {
      title.insertAdjacentHTML(
        'beforebegin',
        '<div class="cart-item__free-gift-label">Free gift</div>'
      );
    }
  }

  handleFreeGift() {
    this.freeGiftSyncing = false;

    const freeGift = document.querySelector('.js-cart-free-gift');

    if (freeGift) {
      this.refreshFreeGift();
    }

    document.body.addEventListener('click', (event) => {
      const close = event.target.closest('.confirmation__close');

      if (!close) return;

      const confirmation = close.closest(
        '.js-cart-free-gift-confirmation'
      );

      if (confirmation) {
        confirmation.classList.remove('active');
      }
    });
  }

  async refreshFreeGift() {
    if (this.freeGiftSyncing) return;

    const freeGift = document.querySelector('.js-cart-free-gift');

    if (!freeGift) return;

    const variantId = parseInt(
      freeGift.getAttribute('data-variant-id'),
      10
    );

    if (!variantId) return;

    try {
      let cart = await this.getCart();

      const giftItem = cart.items.find(item =>
        item.variant_id === variantId &&
        item.properties?._free_gift === 'true'
      );

      if (giftItem) {
        this.protectFreeGiftItemUI(variantId);
        this.updateFreeGiftItemPrice(giftItem);
      }

      cart = await this.syncFreeGift(cart);

      const currentGift = cart.items.find(item =>
        item.variant_id === variantId &&
        item.properties?._free_gift === 'true'
      );

      if (currentGift) {
        this.protectFreeGiftItemUI(variantId);
        this.updateFreeGiftItemPrice(currentGift);
      }

    } catch (error) {
      console.error('Free gift error:', error);
    }
  }

  getFreeGiftQualifyingTotal(
    cart,
    freeGiftVariantId
  ) {
    const freeGiftItem = cart.items.find(
      item =>
        item.variant_id === freeGiftVariantId &&
        item.properties?._free_gift === 'true'
    );

    const freeGiftTotal = freeGiftItem
      ? freeGiftItem.final_line_price
      : 0;

    const giftCardsTotal = cart.items.reduce(
      (total, item) => {
        if (!item.gift_card) {
          return total;
        }

        return total + (
          item.final_line_price ??
          item.line_price ??
          0
        );
      },
      0
    );

    return Math.max(
      cart.total_price -
      freeGiftTotal -
      giftCardsTotal,
      0
    );
  }

  async syncFreeGift(cart) {
    const freeGift = document.querySelector('.js-cart-free-gift');

    if (!freeGift || this.freeGiftSyncing) {
      return cart;
    }

    const threshold = parseInt(
      freeGift.getAttribute('data-threshold'),
      10
    );

    const variantId = parseInt(
      freeGift.getAttribute('data-variant-id'),
      10
    );

    if (!threshold || !variantId) {
      return cart;
    }

    this.freeGiftSyncing = true;

    try {
      let giftItem = cart.items.find(item =>
        item.variant_id === variantId &&
        item.properties?._free_gift === 'true'
      );

      const qualifyingTotal =
        this.getFreeGiftQualifyingTotal(
          cart,
          variantId
        );

      const qualified =
        qualifyingTotal >= threshold;

      if (qualified) {
        if (!giftItem) {
          const addResponse = await fetch(
            window.Shopify.routes.root + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: 1,
                    properties: {
                      '_free_gift': 'true'
                    }
                  }
                ]
              })
            }
          );

          if (!addResponse.ok) {
            throw new Error('Could not add free gift');
          }

          await addResponse.json();

          cart = await this.getCart();

          giftItem = cart.items.find(item =>
            item.variant_id === variantId &&
            item.properties?._free_gift === 'true'
          );

          if (giftItem) {
            this.renderFreeGiftItem(giftItem);
          }

          this.showFreeGiftConfirmation(freeGift);
        }

        else if (giftItem.quantity > 1) {
          await this.changeFreeGiftQuantity(
            giftItem.key,
            1
          );

          cart = await this.getCart();
        }
      }

      else if (giftItem) {
        await this.changeFreeGiftQuantity(
          giftItem.key,
          0
        );

        const giftCartItem = document.querySelector(
          `.js-cart-item[data-variant-id="${variantId}"][data-free-gift="true"]`
        );

        if (giftCartItem) {
          giftCartItem.classList.add('hide-item');

          setTimeout(() => {
            giftCartItem.remove();
          }, 300);
        }

        cart = await this.getCart();
      }

      this.updateCartTotals(cart);

      this.updateFreeGiftUI(
        freeGift,
        cart,
        variantId,
        threshold
      );

      return cart;

    } catch (error) {
      console.error('Free gift sync error:', error);

      return cart;
    } finally {
      this.freeGiftSyncing = false;
    }
  }

  async changeFreeGiftQuantity(key, quantity) {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/change.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      }
    );

    if (!response.ok) {
      throw new Error('Could not update cart item');
    }

    return response.json();
  }

  async getCart() {
    const response = await fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    return response.json();
  }

  updateCartTotals(cart) {
    const subtotalElement = document.querySelector('.js-subtotal-price');
    const subtotalSavingsElement = document.querySelector(
      '.js-subtotal-savings-price'
    );
    const savingsElement = document.querySelector(
      '.js-savings-price'
    );

    let subtotalBeforeSavings = 0;
    let totalSavings = 0;

    const freeGift = document.querySelector('.js-cart-free-gift');

    const freeGiftVariantId = parseInt(
      freeGift?.getAttribute('data-variant-id') || 0,
      10
    );

    const freeGiftOriginalPrice = parseInt(
      freeGift?.getAttribute('data-original-price') || 0,
      10
    );

    cart.items.forEach(item => {
      const quantity = item.quantity || 1;

      const finalPrice =
        item.final_price ??
        item.price ??
        0;

      let originalPrice =
        item.original_price ??
        item.price ??
        finalPrice;

      if (
        freeGiftVariantId &&
        item.variant_id === freeGiftVariantId &&
        item.properties?._free_gift === 'true' &&
        freeGiftOriginalPrice > originalPrice
      ) {
        originalPrice = freeGiftOriginalPrice;
      }

      const subtotalPrice =
        originalPrice > finalPrice
          ? originalPrice
          : finalPrice;

      subtotalBeforeSavings +=
        subtotalPrice * quantity;

      if (originalPrice > finalPrice) {
        totalSavings +=
          (originalPrice - finalPrice) * quantity;
      }
    });

    if (subtotalElement) {
      subtotalElement.innerHTML =
        Shopify.formatMoney(cart.total_price);
    }

    if (subtotalSavingsElement) {
      subtotalSavingsElement.innerHTML =
        Shopify.formatMoney(subtotalBeforeSavings);
    }

    if (savingsElement) {
      savingsElement.innerHTML =
        `-${Shopify.formatMoney(totalSavings)}`;
    }

    document
      .querySelectorAll('.js-cart-counter')
      .forEach(counter => {
        counter.innerHTML = cart.item_count;

        counter.setAttribute(
          'data-counter',
          cart.item_count
        );
      });
  }

  showFreeGiftConfirmation(freeGift) {
    const confirmation = freeGift.querySelector(
      '.js-cart-free-gift-confirmation'
    );

    if (!confirmation) return;

    confirmation.classList.add('active');
  }

  updateFreeGiftUI(
    freeGift,
    cart,
    variantId,
    threshold
  ) {
    const qualifyingTotal =
      this.getFreeGiftQualifyingTotal(
        cart,
        variantId
      );

    const amountLeft = Math.max(
      threshold - qualifyingTotal,
      0
    );

    const progress = Math.min(
      (qualifyingTotal / threshold) * 100,
      100
    );

    const progressBar = freeGift.querySelector(
      '.js-cart-free-gift-progress'
    );

    const message = freeGift.querySelector(
      '.js-cart-free-gift-message'
    );

    if (progressBar) {
      progressBar.style.width = `${progress}%`;
    }

    if (message) {
      message.classList.toggle(
        'active',
        amountLeft > 0
      );

      const paragraphs = message.querySelectorAll('p');

      if (paragraphs[0]) {
        const template =
          freeGift.getAttribute('data-progress-text');

        if (template) {
          paragraphs[0].innerHTML = template.replace(
            '[amount]',
            Shopify.formatMoney(amountLeft)
          );
        }
      }
    }
  }

  handleCartNote() {
    document.body.addEventListener('change', async (event) => {
      const textarea = event.target.closest('.js-cart-note');
      if (!textarea || !this.contains(textarea)) return;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ note: textarea.value })
        });

        if (!response.ok) {
          throw new Error('Could not save cart note');
        }
      } catch (error) {
        console.error('Cart note update error:', error);
      }
    });
  }

  updateCartRecommendations(cart) {
    const productIds = new Set(
      cart.items.map(item => String(item.product_id))
    );

    document.querySelectorAll('.js-cart-recommendation').forEach(element => {
      element.style.display = productIds.has(element.dataset.productId)
        ? 'none'
        : '';
    });
  }

  handleBlockSelect() {
    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail.blockId;
      const blockEl = document.querySelector(`[data-block-id="${blockId}"]`);
      if (!blockEl) return;

      const cartContent = document.querySelector('.js-cart-content');
      if (!cartContent) return;

      const isInsideNotEmptyCart = blockEl.closest('.drawer-cart__not-empty');

      if (isInsideNotEmptyCart) {
        cartContent.classList.remove('drawer-cart__content--empty');
      } else {
        cartContent.classList.add('drawer-cart__content--empty');
      }

      const drawerCart = blockEl.closest('drawer-cart');
      if (!drawerCart) return;

      const drawer = drawerCart.querySelector('.js-drawer-cart');
      if (!drawer || drawer.classList.contains('active')) return;

      drawer.classList.add('display');

      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      setTimeout(() => {
        drawer.classList.add('active');
      }, 50);
    });
  }
}

customElements.define('drawer-cart', Cart);